import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-403591c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "file-btns header-scorll" }
const _hoisted_3 = { class: "btns" }
const _hoisted_4 = { class: "inputs" }
const _hoisted_5 = { class: "selects" }
const _hoisted_6 = {
  class: "tool-bar",
  style: {"margin-top":"4px"}
}
const _hoisted_7 = { class: "info-bar" }
const _hoisted_8 = { class: "info-bar" }
const _hoisted_9 = { style: {"flex":"auto"} }
const _hoisted_10 = {
  class: "operate-num",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "本次发货数量非整件，请仔细核对", -1))
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  class: "vxe-cell--label"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "vxe-cell--placeholder" }, "请点击选择", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 0,
  style: {"display":"flex","align-items":"center","gap":"4px"}
}
const _hoisted_17 = { style: {"display":"flex","align-items":"center","justify-content":"space-between","height":"50px"} }
const _hoisted_18 = { class: "price-info" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "price-num" }
const _hoisted_21 = { class: "price-label price-label-more" }
const _hoisted_22 = { class: "price-num" }
const _hoisted_23 = { class: "price-label price-label-more" }
const _hoisted_24 = { class: "price-num" }
const _hoisted_25 = { style: {"display":"flex","align-items":"center","column-gap":"12px"} }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"margin-bottom":"0"} }, "已审核的要货计划", -1))
const _hoisted_27 = { style: {"margin-top":"12px"} }
const _hoisted_28 = { style: {"height":"200px","flex":"auto"} }
const _hoisted_29 = { style: {"display":"flex","column-gap":"12px"} }
const _hoisted_30 = { style: {"display":"flex","flex":"none","margin-top":"10px"} }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "将", -1))
const _hoisted_32 = { style: {"width":"300px"} }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "修改为", -1))
const _hoisted_34 = { style: {"width":"300px"} }
const _hoisted_35 = { class: "operation-col" }


const __default__ = {
  name: 'SendGoods',
  inheritAttrs: false
};

import dayjs, { Dayjs } from 'dayjs';
import { computed, ref, watch, reactive, nextTick, onMounted } from 'vue';
import { OioButton, OioForm, OioFormItem, OioInput, OioModal, OioSpin, OioDatePicker, OioRow, OioCol, OioTag, OioMessage, OioSwitch } from '@kunlun/vue-ui-antd';
import { PlusCircleOutlined, MinusCircleOutlined, FullscreenExitOutlined, FullscreenOutlined, ExclamationCircleOutlined, DownOutlined, UpOutlined } from '@ant-design/icons-vue';
import { VxeButtonEvents, VxeTablePropTypes } from 'vxe-table';
import { Modal, message } from 'ant-design-vue';
import { ElTooltip } from 'element-plus';
import { cloneDeep, debounce, isNil } from 'lodash-es';
import { PopupManager, RuntimeModel, executeServerAction, ServerActionCache } from '@kunlun/dependencies';
import { removeDecimalZero } from '../../../../utils/number';
import { vxeTableRemoveZeroFormatter } from '../../../../utils/fotmatter';
import { useFullscreen } from '../../../../hooks/fullscreen';
import ImportDialog from '../../../../components/ImportDialog/ImportDialog.vue';
import {
  fetchPurchasingPlan,
  fetchPurchasingPlanDetail,
  queryAddressDetail,
  queryWareHouse as queryWareHouseApi,
  queryWareHouseDeliveryTypeSwitchList,
  tmsFreshInventoryConstruct,
  getAccountBalance,
  dealOption
} from './services';
import { TIssuingMethod, useProxyDelivery, useProductPackage } from '../../../../hooks';
import { fetchLogisticsProviders } from '../../../../api';
import { tagColorMap, tagViewMap } from '../../../../constants';
import { UnwrapPromise } from '../../../../types';
import { ShowSearchType } from 'ant-design-vue/lib/cascader';
import Decimal from 'decimal.js';
import { calcKarNum } from '../../../../utils/productPackage';
import ActionRender from './components/ActionRender.vue';

interface IProps {
  data: any;
  rModel: RuntimeModel;
  inventoryStatusEnum: any[];
  initData: any;
  setData: (value: any, property?: string) => void;
  submitData: any;
  dataLoading: any;
  exportFile: any;
  formatInventoryStatus: any;
  mirrorConstruct: (
    changeType: 'operateNum' | 'sellerDeliveryWarehouse' | 'isTransfer',
    selectedWarehouse?: boolean,
    updatePart?: boolean,
    batchEditModalOperatorNum?: number,
    batchEditIsTransfer?: boolean
  ) => Promise<void>;
  mountedProcess: (refresh?: boolean) => void;
  mountedProcessSignal: boolean;
  modelStr: any;
  importModel: RuntimeModel;
  openPlanDetail: any;
  onAllCancel: Function;
  onPartCancel: Function;
  allCancelAction: boolean;
  partCancelAction: boolean;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    data: null,
    rModel: null,
    inventoryStatusEnum: null,
    initData: null,
    setData: null,
    submitData: null,
    dataLoading: null,
    exportFile: null,
    formatInventoryStatus: null,
    mirrorConstruct: null,
    mountedProcess: null,
    mountedProcessSignal: { type: Boolean },
    modelStr: null,
    importModel: null,
    openPlanDetail: null,
    onAllCancel: null,
    onPartCancel: null,
    allCancelAction: { type: Boolean },
    partCancelAction: { type: Boolean }
  },
  setup(__props: any, { emit }: { emit: ({}), expose: any, slots: any, attrs: any }) {

const props = __props as { data: any, rModel: RuntimeModel, inventoryStatusEnum: any[], initData: any, setData: (value: any, property?: string) => void, submitData: any, dataLoading: any, exportFile: any, formatInventoryStatus: any, mirrorConstruct: (
    changeType: 'operateNum' | 'sellerDeliveryWarehouse' | 'isTransfer',
    selectedWarehouse?: boolean,
    updatePart?: boolean,
    batchEditModalOperatorNum?: number,
    batchEditIsTransfer?: boolean
  ) => Promise<void>, mountedProcess: (refresh?: boolean) => void, mountedProcessSignal: boolean, modelStr: any, importModel: RuntimeModel, openPlanDetail: any, onAllCancel: Function, onPartCancel: Function, allCancelAction: boolean, partCancelAction: boolean }




const addressFormRef = ref<InstanceType<typeof OioForm>>();
const customerDemandFormRef = ref<InstanceType<typeof OioForm>>();

const { generateConvertRelationStr, convertToLargePackage } = useProductPackage();
const runOnce = ref<boolean>(true);
const ariesIssuingMethodEnum = computed<TIssuingMethod>({
  get: () => {
    if (props.data?.mainData?.ariesIssuingMethodEnum) {
      return props.data.mainData.ariesIssuingMethodEnum;
    }
    const options = props.data?.mainData?.ariesIssuingMethodOptions;
    if (options?.length) {
      return options.find((i) => i.value === 'NOMAL')?.value || options[0].value;
    } else {
      return '';
    }
  },
  set: async (val) => {
    props.setData(val, 'mainData.ariesIssuingMethodEnum');
    if (runOnce.value) {
      await handleAriesIssuingMethodChange(null);
      runOnce.value = false;
    }
  }
});
const {
  deliveryAddressTypeEnum,
  deliveryAreaTypeEnum,
  sendAreaDisabled,
  sendAreaOptions,
  addressTypeOptions,
  pickerShippingType,
  showCustomAddress,
  tmsDeliveryMethod,
  warehouseDeliveryTypeOptions,
  goodsTagsTypeEnum
} = useProxyDelivery(ariesIssuingMethodEnum);

let count = 1;
const searchVal = ref('');
const searchBGVal = ref('');
const searchERPStoreCodeVal = ref('');
const deliAriesInventoryStatusEnum = ref();
const tableDetailRef = ref<any>();
const logisticsProviderOptions = ref<any[]>([]);
const detailPagination = reactive({
  page: 1,
  size: 10,
  total: 0
});
const detailTableData = ref<any[]>([]);
const maxOperateNumMap = ref<Record<string, number>>({});
const wareHouseDeliveryTypeSwitchList = ref<UnwrapPromise<ReturnType<typeof queryWareHouseDeliveryTypeSwitchList>>>([]);
const editModalDataList = ref<{ type?: (typeof originalEditTypeOptions)[number]['value']; value?: any; id: number }[]>([{ id: 0 }]);
const allWarehouseOptions = ref<any[]>([]);
const tableRef = ref<any>();
const exportLoading = ref(false);
const tableLoading = ref(false);
const editModalVisible = ref(false);
const editModalConfirmLoading = ref(false);
const submitLoading = ref(false);
const addressModalVisible = ref(false);
const customerDemandVisible = ref(false);

const customerDemandOpt = ref<any>();
const customerDemandOptions = ref([{value : 'MarkCustomerDemandNoDirect',label : '客需（非直发）'},{value : 'MarkCustomerDemandDirect',label : '客需（总部直发）'},{ value : 'isMarkPackagingMaterialsCustomerDemandDirect', label:'包材客需（直发）'},{ value : 'isMarkPackagingMaterialsCustomerDemandNoDirect', label:'包材客需（非直发）'}])
const displayTableData = ref<any[]>([]);
const _selectedRegion = ref<string[]>([]);
const productTableDataHistoryArr = ref<any[]>([]);
const isApplyPlan = ref(false);
const disabledEditFields = reactive<{ operateNum: Record<string, number> }>({
  operateNum: {}
});
const tagesValueArr = ref<any[]>([]);
const editStatus = ref<'OPEN' | 'CLOSED'>('CLOSED');
// 前端扩展字段，提交时删除，key为商品明细行的tradeOrderDetailId
const expandFieldsMap = reactive<Record<string, any>>({});
const planDetailObj = reactive<Record<string, any>>({});
const isExpandPlan = ref(false);

const initWarehouseDeliveryTypeSwitchList = async () => {
  wareHouseDeliveryTypeSwitchList.value = await queryWareHouseDeliveryTypeSwitchList();
};
initWarehouseDeliveryTypeSwitchList();

const selectRecords = computed(() => props.data.mainData?.tmsOrderDetails?.filter((i) => i.isSelected) ?? []);

// 发货计算逻辑
const calcSingleAmount = (record) => {
  //行结算金额
  const total = new Decimal(record.settlementAmountTrade);
  //本次发货数量
  const delivery = new Decimal(record.operateNum || 0);
  //商品总数
  const itemTotal = new Decimal(record.orderDetailItemNum || 0);
  //取消商品数
  const closed = new Decimal(record.orderDetailClosedNum || 0);
  //已发货数
  const delivered = new Decimal(record.deliveredNum || 0);
  // 计算可发货总数 = 商品总数 - 已关闭数
  const maxDelivery = itemTotal.sub(closed);
  // 判断是否最后一次发货
  if (delivery.eq(maxDelivery)) {
    // 最终次：总金额 - 已发货部分
    const historyPart = total.mul(delivered).div(maxDelivery).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
    return total.sub(historyPart).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
  }
  // 常规计算：按比例计算本次金额
  return total.mul(delivery).div(maxDelivery).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
};

// 计算发货合计
const totalAmount = computed(() => {
  return selectRecords.value.reduce((sum, record) => {
    return sum.add(calcSingleAmount(record))
  }, new Decimal(0)).toNumber()
});

// 计算发货数量合计（件），勾选行明细的本次发货数量（PCS）按换算关系换算为 Kar（件）后求和
const totalKarNum = computed(() => {
  return selectRecords.value.reduce((sum, record) => {
    const karNum = convertToLargePackage(record.operateNum || 0, 'PCS', 'KAR', record.itemSpecifications) || 0;
    return sum.add(new Decimal(karNum));
  }, new Decimal(0));
});

const warehouseDeliveryTypeDisabled = computed(
  () => !(wareHouseDeliveryTypeSwitchList.value.find((i) => i.ariesIssuingMethodEnum === ariesIssuingMethodEnum.value)?.enableWarehouseDeliveryType ?? false)
);

const filterAddressInfo: ShowSearchType['filter'] = (inputValue, path) => {
  return path.some((option) => option.name.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
};

const beforeEditMethod = ({ row, column }) => {
  const { tradeOrderDetailId } = row;
  const { title } = column;
  const columnKeyMap = {
    本次发货数量: 'operateNum',
    发货仓库: 'sellerDeliveryWarehouse'
  };
  if (disabledEditFields[columnKeyMap[title]]?.[tradeOrderDetailId + '']) {
    return false;
  }
  return true;
};

const handleDeliveryAddressTypeChange = (e) => {
  // 切换到其他地址时，清空地址信息
  if (deliveryAddressTypeEnum.value === 'OTHER') {
    _selectedRegion.value = [];
  }
  props.setData(e.target.value, 'mainData.deliveryAddressTypeEnum');
};

const handleEditArress = async () => {
  onApplyAddressEdit();
  addressModalVisible.value = false;
};

watch(addressModalVisible, (val) => {
  if (!val) {
    handleEditArress();
  }
});

watch(
  warehouseDeliveryTypeDisabled,
  (val) => {
    if (val) {
      // 默认整散件
      props.setData('PARTS_AND_ALL', 'mainData.warehouseDeliveryTypeEnum');
    }
  },
  { immediate: true }
);

const originalEditTypeOptions: {
  label: string;
  value: Parameters<typeof onTableDataChange>[0]['changeType'];
}[] = [
  { label: '本次发货数量', value: 'operateNum' },
  { label: '发货仓库', value: 'sellerDeliveryWarehouse' }
  // { label: '是否转配', value: 'isTransfer' }
  // { label: '取消原因', value: 'qxyy' }
];
const displayEditTypeOptions = computed(() => {
  type Writeable<T> = { -readonly [P in keyof T]: T[P] };
  const copy: any[] = cloneDeep(originalEditTypeOptions as Writeable<typeof originalEditTypeOptions>);
  copy.forEach((item) => {
    if (editModalDataList.value.some((data) => data.type === item.value)) {
      item.disabled = true;
    } else {
      item.disabled = false;
    }
  });
  return copy;
});

const updateLogisticsOptions = async () => {
  const res = await fetchLogisticsProviders(props.rModel, { ariesIssuingMethodEnum: ariesIssuingMethodEnum.value });
  logisticsProviderOptions.value = res.map((i) => ({
    label: i.name,
    value: i.code
  }));
  // 如果不存在选项中，就清空
  if (!logisticsProviderOptions.value.find((i) => i.value === props.data.mainData.logisticsCode)) {
    props.setData('', 'mainData.logisticsCode');
  }
};

const getWarehouseById = (id, row?: any) => {
  // 单行
  if (row) {
    return expandFieldsMap[row.tradeOrderDetailId]?.warehouseOptions?.find((i) => i.id === id) ?? {};
  }
  // 批量
  else {
    return allWarehouseOptions.value.find((i) => i.id === id) ?? {};
  }
};

const handleSearchWarehouse = async (params?: { code?: string; name?: string; row?: any; searchKey?: string }) => {
  const { code = '', name = '', row = undefined as any, searchKey = '' } = params || {};
  const tmsOrderDetails: any[] | undefined | null = props.data.mainData?.tmsOrderDetails;
  const searchParams: Parameters<typeof queryWareHouseApi>[1] = {
    searchKey,
    shopId: props.data.mainData?.shop?.id ?? null,
    salesOfficeId: props.data.mainData?.salesOfficeId ?? null,
    buyerPartnerId: props.data.mainData?.buyerPartnerId ?? null,
    distributionChannelId: props.data.mainData?.distributionChannelId ?? null,
    code,
    name,
    bizType: props.data.mainData?.bizType,
    tradeOrderCode: props.data.mainData?.tradeOrderCode,
    ariesIssuingMethodEnum: ariesIssuingMethodEnum.value,
    warehouseDeliveryTypeEnum: props.data.mainData?.warehouseDeliveryTypeEnum
  };
  if (tmsOrderDetails) {
    searchParams.saleSkuTplIdList = tmsOrderDetails
      .map((it) => it.saleSkuTplId)
      .filter((it) => it && it !== '')
      .join(',');
  }
  if (row) {
    searchParams.saleSkuTplId = row.saleSkuTplId;
    searchParams.deliveryAddress = props.data.mainData.deliveryAddress;
    searchParams.itemTplCode = row.itemtplCode;
  }
  if (searchParams.saleSkuTplId) {
    searchParams.itemOutCode = row.itemOutCode;
  }
  // else {
  //   searchParams.resourceAddress = props.data.mainData.deliveryAddress.address;
  // }

  const res = (await queryWareHouseApi(props.rModel, searchParams)) ?? [];
  if (row) {
    if (!res.find((i) => i.id == row.sellerDeliveryWarehouse?.id) && row.sellerDeliveryWarehouse) {
      res.push(row.sellerDeliveryWarehouse);
    }
    setExpandProperty(row.tradeOrderDetailId, 'warehouseOptions', res);
  } else {
    allWarehouseOptions.value = res;
  }
};

const debounceSearchWarehouse = debounce(handleSearchWarehouse, 500);

const handleWarehouseChange = (id, row) => {
  row.sellerDeliveryWarehouse = getWarehouseById(id, row);
  onTableDataChange({ changeType: 'sellerDeliveryWarehouse', row, selectedWarehouse: true });
};

watch(
  () => props.data.mainData.tmsDeliveryMethod,
  (val) => {
    if (val === 'LOGISTICS') {
      updateLogisticsOptions();
    }
    tmsDeliveryMethod.value = val;
  },
  {
    immediate: true
  }
);

const checkboxChangeEvent = (updateDataAfterChange = true) => {
  updateDataAfterChange && onTableDataChange({ changeType: 'operateNum' });
};

const checkboxChangeEventDetail = () => {};
const selectModel = ref<boolean>(true);
const selectModelOptions = [
  {
    label: '包含',
    value: true
  },
  {
    label: '不包含',
    value: false
  }
];

const updateDisplayTableData = async (isCurrentImport = false) => {
  const oriData = props.data.mainData?.tmsOrderDetails ?? [];
  oriData.forEach((row) => {
    // 没有对应的选项时聚焦会显示id，所以需要设置选项来显示名称
    if (
      !expandFieldsMap[row.tradeOrderDetailId]?.warehouseOptions ||
      !expandFieldsMap[row.tradeOrderDetailId]?.warehouseOptions?.find((i) => i.id == row.sellerDeliveryWarehouse?.id)
    ) {
      const options = row.sellerDeliveryWarehouse ? [row.sellerDeliveryWarehouse] : [];
      setExpandProperty(row.tradeOrderDetailId, 'warehouseOptions', options);
    }
  });
  const keyList = searchVal.value.split(/[ \t\n]/).filter((s) => s);
  const keyBGList = searchBGVal.value.split(/[ \t\n]/).filter((s) => s);

  tableRef.value?.clearCheckboxRow();

  if (keyList.length === 0 && !searchERPStoreCodeVal.value.trim() && keyBGList.length == 0) {
    displayTableData.value = oriData;
  } else {
    displayTableData.value = oriData.filter((item) => {
      const condition1 = keyList.length ? keyList.some((key) => ((item.itemOutCode ?? '') + (item.itemName ?? '') + (item.productOutCode ?? ''))?.includes?.(key)) : true;

      const condition2 = searchERPStoreCodeVal.value.trim() ? item.sellerDeliveryWarehouse?.name?.includes(searchERPStoreCodeVal.value.toLocaleUpperCase()) : true;

      const condition3 = keyBGList.length ? keyBGList.some((key) => ((item.productBelong ?? ''))?.includes?.(key)) : true;
      return condition1 && condition2 && condition3;
    });
  }

  if (deliAriesInventoryStatusEnum.value) {
    displayTableData.value = displayTableData.value.filter((item) => {
      const enumValue = item.deliAriesInventoryStatusEnum || 'NOT_SATISFIED';
      return enumValue === deliAriesInventoryStatusEnum.value;
    });
  }

  if (tagesValueArr.value.length > 0 && selectModel.value !== undefined) {
    tableLoading.value = true;
    displayTableData.value = displayTableData.value.filter((product) => {
      if (selectModel.value) {
        return tagesValueArr.value.some((tag) => product?.tradeOrderOptions?.includes(tag));
      } else {
        return !tagesValueArr.value.some((tag) => product?.tradeOrderOptions?.includes(tag));
      }
    });
    tableLoading.value = false;
  }

  await nextTick();

  // 前提：【整件/整散件】筛选，选择「整件」后：
  // 1、【无要货计划】：FUN-向下取整正整数「MIN(待发货数量, 可用库存)/换算关系(Kar,最大的规格)」，此时「本次发货数量=本次发货件数*换算关系」
  // 2、【应用了要货计划】：FUN-向下取整正整数「MIN(当前要货待发数量, 可用库存)/换算关系(Kar,最大的规格)」，此时「本次发货数量=本次发货件数*换算关系」
  // 3、【有要货计划但未应用要货计划】：FUN-向下取整正整数「MIN(待发货数量-总要货待发数量，可用库存)/换算关系(Kar,最大的规格)」，此时「本次发货数量=本次发货件数*换算关系」
  if (props.data.mainData.warehouseDeliveryTypeEnum === warehouseDeliveryTypeOptions[0].value && !isCurrentImport) {
    displayTableData.value.forEach((item) => {
      // 换算关系
      const itemRelation = Number(generateConvertRelationStr(item.itemSpecifications).split('/').pop()!);
      const availableNum = item.availableNum ?? 0; // 可用库存
      const undeliveredNum = item.undeliveredNum ?? 0; // 待发货数量
      const totalPendingNum = Math.max(0, item.purchasePlanNum - item.deliveredNum ?? 0); // 总要货待发数量(总要货数量:purchasePlanNum - 已发货数量:deliveredNum)

      const hasUsePlan =
        props.data.mainData.purchasingPlanCode &&
        detailTableData.value.some((d) => {
          const deliAriesPurchasingPlanDetails = d.deliAriesPurchasingPlanDetails || [];
          return d.applied && deliAriesPurchasingPlanDetails.some((p) => p.tradeDetailId === item.tradeOrderDetailId);
        });
      let operateNum = 0;
      if (!detailTableData.value.length) {
        operateNum = Math.floor(Math.min(undeliveredNum, availableNum) / itemRelation) * itemRelation;
      } else if (hasUsePlan) {
        const unAllocedNum = planDetailObj[item.tradeOrderDetailId]?.unAllocedNum ?? 0; // 当前要货待发数量
        operateNum = Math.floor(Math.min(unAllocedNum, availableNum) / itemRelation) * itemRelation;
      } else {
        operateNum = Math.floor(Math.min(undeliveredNum - totalPendingNum, availableNum) / itemRelation) * itemRelation;
      }
      item.operateNum = operateNum ? operateNum : 0;
    });
  }

  tableRef.value?.setCheckboxRow(displayTableData.value, true);
};
const filterInventoryStatus = () => {
  updateDisplayTableData();
};

watch(
  () => props.data.mainData?.tmsOrderDetails,
  (val) => {
    calcKarNum(val, 'itemSpecifications', 'operateNum', 'itemKarNum');
  },
  {
    deep: true
  }
);

const onWareHouseDeliveryChange = async () => {
  await onTableDataChange({ changeType: 'sellerDeliveryWarehouse' });
};

const exportDataEvent: VxeButtonEvents.Click = () => {
  try {
    exportLoading.value = true;
    props.exportFile(displayTableData.value);
  } catch (error) {
    console.error(error);
  } finally {
    exportLoading.value = false;
  }
};

const setSubmitRow = (tradeOrderDetailId) => {
  const originDetailList = props.data.mainData.tmsOrderDetails;
  originDetailList.forEach((i) => {
    if (i.tradeOrderDetailId === tradeOrderDetailId) {
      i.isPartSubmitRow = true;
    } else {
      delete i.isPartSubmitRow;
    }
  });
  props.setData(originDetailList, 'mainData.tmsOrderDetails');
};

const setSubmitRows = (tradeOrderDetailIds, isExclude = false) => {
  const originDetailList = props.data.mainData.tmsOrderDetails;
  originDetailList.forEach((i) => {
    if ((!isExclude && tradeOrderDetailIds.includes(i.tradeOrderDetailId)) || !tradeOrderDetailIds.includes(i.tradeOrderDetailId)) {
      i.isPartSubmitRow = true;
    } else {
      delete i.isPartSubmitRow;
    }
  });
  props.setData(originDetailList, 'mainData.tmsOrderDetails');
};

const resetAllSubmitRow = () => {
  const originDetailList = props.data.mainData.tmsOrderDetails;
  originDetailList.forEach((i) => {
    delete i.isPartSubmitRow;
  });
  props.setData(originDetailList, 'mainData.tmsOrderDetails');
};

const setExpandProperty = (pk: string, expandKey, value: any) => {
  if (!expandFieldsMap[pk]) {
    expandFieldsMap[pk] = {};
  }
  expandFieldsMap[pk][expandKey] = value;
};

// 批量修改中的「本次发货数量」
let batchEditModalOperatorNum = null as any;
//批量修改中的「是否转配」
// let batchEditIsTransfer = null as any;

const onTableDataChange = async ({
  changeType = '' as 'operateNum' | 'sellerDeliveryWarehouse' | 'isTransfer' | 'allocItemStatusType',
  row = null as any,
  isBatchEdit = false,
  selectedWarehouse = false
}) => {
  if (row) {
    if (changeType === 'operateNum' && maxOperateNumMap[row.tradeOrderDetailId] && row.operateNum > maxOperateNumMap[row.tradeOrderDetailId] && isApplyPlan.value) {
      message.warning('当前行的本次发货数量不能大于应用的要货计划中该商品的要货数量');
      setExpandProperty(row.tradeOrderDetailId, 'isAbovePlanProductNum', true);
      return;
    } else {
      setExpandProperty(row.tradeOrderDetailId, 'isAbovePlanProductNum', false);
    }
  }
  if (changeType === 'operateNum' && isBatchEdit && isApplyPlan.value) {
    const tmsOrderDetailsCopy = cloneDeep(props.data.mainData.tmsOrderDetails);
    tmsOrderDetailsCopy.forEach((i) => {
      if (i.operateNum > maxOperateNumMap[i.tradeOrderDetailId]) {
        message.warning('本次发货数量不能大于应用的要货计划中该商品的要货数量，核对时请先清空搜索条件');
        i.operateNum = maxOperateNumMap[i.tradeOrderDetailId];
        setExpandProperty(row.tradeOrderDetailId, 'isAbovePlanProductNum', true);
      } else {
        setExpandProperty(row.tradeOrderDetailId, 'isAbovePlanProductNum', false);
      }
    });
    props.setData(tmsOrderDetailsCopy, 'mainData.tmsOrderDetails');
  }

  if (changeType === 'sellerDeliveryWarehouse') {
    editStatus.value = 'CLOSED';
  }

  if (changeType === 'operateNum' || changeType === 'isTransfer' || changeType === 'allocItemStatusType') return;

  try {
    tableLoading.value = true;
    if (row) {
      setSubmitRow(row.tradeOrderDetailId);
    } else if (isApplyPlan.value) {
      const excludeIds = Object.keys(disabledEditFields.operateNum);
      setSubmitRows(excludeIds, true);
    } else {
      resetAllSubmitRow();
    }
    await props.mirrorConstruct(
      changeType,
      selectedWarehouse,
      isApplyPlan.value || !!row,
      batchEditModalOperatorNum
      // batchEditIsTransfer
    );
  } finally {
    tableLoading.value = false;
  }
};

const disabledDate = (current: Dayjs) => {
  return current && current < dayjs().startOf('day');
};

// 初始化
const stop2 = watch(
  () => props.mountedProcessSignal,
  async (val) => {
    if (val) {
      checkboxChangeEvent(false);

      ariesIssuingMethodEnum.value = props.data.mainData.ariesIssuingMethodEnum;
      await nextTick();
      tmsDeliveryMethod.value = props.data.mainData.tmsDeliveryMethod;
      deliveryAddressTypeEnum.value = props.data.mainData.deliveryAddressTypeEnum;
      deliveryAreaTypeEnum.value = props.data.mainData.deliveryAreaTypeEnum;

      stop2();
    }
  }
);

const addEditModalRow = () => {
  editModalDataList.value.push({
    id: count++
  });
};
const removeEditModalRow = (id: number) => {
  editModalDataList.value = editModalDataList.value.filter((item) => item.id !== id);
};

const applyBatchEdit = async () => {
  const existingOperateNum = editModalDataList.value.find((v) => v.type === 'operateNum');
  // const existingIsTransfer = editModalDataList.value.find((v) => v.type === 'isTransfer');
  if (!!existingOperateNum) {
    batchEditModalOperatorNum = existingOperateNum.value;
  }
  // if (!!existingIsTransfer) {
  //   batchEditIsTransfer = existingIsTransfer.value;
  // }

  for (const { type, value } of editModalDataList.value) {
    if (!type) {
      continue;
    }
    // 未勾选则修改全部
    const changeAll = selectRecords.value.length === 0;
    const tmsOrderDetailsCopy = displayTableData.value;
    for (const item of tmsOrderDetailsCopy) {
      if (
        !changeAll &&
        // 未选中行不修改
        !selectRecords.value.some((row) => row?.tradeOrderDetailId === item.tradeOrderDetailId)
      ) {
        continue;
      }
      // 当前行的仓库选项未包含修改后的仓库时，将当前行可用库存、本次发货数量设置为0
      if (type === 'sellerDeliveryWarehouse' && !expandFieldsMap[item.tradeOrderDetailId]?.warehouseOptions?.find((i) => i.id === value?.id)) {
        item.operateNum = 0;
        item.availableNum = 0;
        // 下拉选项添加当前仓库值以便中文能显示
        setExpandProperty(item.tradeOrderDetailId, 'warehouseOptions', [...(expandFieldsMap[item.tradeOrderDetailId]?.warehouseOptions || []), value]);
      }
      item[type] = value;
    }

    let selectedWarehouse = false;
    if (type === 'sellerDeliveryWarehouse') {
      selectedWarehouse = true;
    }
    // eslint-disable-next-line no-await-in-loop
    await onTableDataChange({ changeType: type, isBatchEdit: true, selectedWarehouse });
  }

  batchEditModalOperatorNum = null;
  // batchEditIsTransfer = null;
};

const onSubmitBatchEdit = async () => {
  editModalConfirmLoading.value = true;
  try {
    await applyBatchEdit();
    editModalDataList.value = [{ id: count++ }];
    editModalVisible.value = false;
  } finally {
    editModalConfirmLoading.value = false;
  }
};

// ========== 导入校验：模板分发机制 ==========
// 通用基础校验：校验 ERP商品编码是否存在且唯一
const validateBase = (item: Record<any, any>, originDataList: any[], generateErrorObj: (obj: any, message: string) => any) => {
  const targetList = originDataList.filter((el) => el.itemOutCode === item.itemOutCode);
  if (targetList.length === 0) {
    return generateErrorObj(item, '该ERP商品编码不存在于发货单明细中');
  }
  if (targetList.length > 1) {
    return generateErrorObj(item, '该ERP商品编码在发货单明细中不唯一');
  }
  return null;
};

// 原始模板【批量修改商品发货数量】校验逻辑
const validateForOperateNum = (dataList: Record<any, any>[]) => {
  const originDataList = props.data.mainData.tmsOrderDetails;
  const result: Record<any, any>[] = [];
  const generateErrorObj = (obj, message) => ({ ...obj, validateMsg: message });
  dataList.forEach((item) => {
    if (!item.itemOutCode || !item.operateNum || !item.packgeunit) {
      result.push(generateErrorObj(item, '请补充必填字段'));
      return;
    }
    const baseError = validateBase(item, originDataList, generateErrorObj);
    if (baseError) {
      result.push(baseError);
      return;
    }
    const target = originDataList.filter((el) => el.itemOutCode === item.itemOutCode)[0];
    if (!target.itemSpecifications?.some((el) => el.unitCode === item.packgeunit)) {
      result.push(generateErrorObj(item, `对应商品不存在所选的包装单位（可选：${target.itemSpecifications.map((el) => el.unitCode).join(',')}）`));
      return;
    }
    result.push(item);
  });
  return result;
};

// 新增模板【批量修改客需数量】校验逻辑
// 模板头包含 itemOutCode、customerDemandNum 字段，校验两者不能为空
const validateForCustomerDemand = (dataList: Record<any, any>[]) => {
  const originDataList = props.data.mainData.tmsOrderDetails;
  const result: Record<any, any>[] = [];
  const generateErrorObj = (obj, message) => ({ ...obj, validateMsg: message });
  dataList.forEach((item) => {
    if (!item.itemOutCode || !item.customerDemandNum) {
      result.push(generateErrorObj(item, '请补充必填字段（ERP商品编码、本次客需数量）'));
      return;
    }
    const baseError = validateBase(item, originDataList, generateErrorObj);
    if (baseError) {
      result.push(baseError);
      return;
    }
    result.push(item);
  });
  return result;
};

// 模板名 → 专用校验函数 映射表
const templateValidateMap: Record<string, (dataList: Record<any, any>[]) => Record<any, any>[]> = {
  '批量修改客需数量': validateForCustomerDemand
};

// 导入校验分发函数：根据模板名调用对应校验逻辑
const validateImport = (dataList: Record<any, any>[], templateName?: string) => {
  const validateFn = templateName ? templateValidateMap[templateName] : undefined;
  if (validateFn) {
    return validateFn(dataList);
  }
  // fallback：原始模板校验逻辑
  return validateForOperateNum(dataList);
};

// ========== 导入回调：模板分发机制 ==========
const isImport = ref<boolean>(false);
// 原始模板【批量修改商品发货数量】回调逻辑
const importCallbackForOperateNum = async (dataList: Record<any, any>[]) => {
  const tmsOrderDetailsCopy = cloneDeep(props.data.mainData.tmsOrderDetails);
  dataList.forEach((item) => {
    const target = tmsOrderDetailsCopy.find((el) => el.itemOutCode === item.itemOutCode);
    const pcsCount = target.itemSpecifications.find((el) => el.unitCode === item.packgeunit).pcsCount;
    target.operateNum = Number(item.operateNum) * pcsCount;
  });
  props.setData(tmsOrderDetailsCopy, 'mainData.tmsOrderDetails');
  await onTableDataChange({ changeType: 'operateNum' });
};
// 新增模板【批量修改客需数量】回调逻辑
const importCallbackForCustomerDemand = async (dataList: Record<any, any>[]) => {
  const tmsOrderDetailsCopy = cloneDeep(props.data.mainData.tmsOrderDetails);
  dataList.forEach((item) => {
    const target = tmsOrderDetailsCopy.find((el) => el.itemOutCode === item.itemOutCode);
    if (target) {
      target.customerDemandNum = Number(item.customerDemandNum);
    }
  });
  props.setData(tmsOrderDetailsCopy, 'mainData.tmsOrderDetails');
};
// 模板名 → 专用回调函数 映射表
const templateCallbackMap: Record<string, (dataList: Record<any, any>[]) => Promise<void>> = {
  '批量修改客需数量': importCallbackForCustomerDemand
};
// 导入回调分发函数：根据模板名调用对应回调逻辑
const importCallback = async (dataList: Record<any, any>[], templateName?: string) => {
  try {
    isImport.value = true;
    const callbackFn = templateName ? templateCallbackMap[templateName] : undefined;
    if (callbackFn) {
      await callbackFn(dataList);
      return;
    }
    // fallback：原始模板回调逻辑
    await importCallbackForOperateNum(dataList);
  } finally {
    isImport.value = false;
  }
};
watch(
  [() => props.data.mainData?.tmsOrderDetails, searchVal, searchBGVal, searchERPStoreCodeVal, deliAriesInventoryStatusEnum],
  () => {
    const currentIsImport = isImport.value;
    setTimeout(() => {
      updateDisplayTableData(currentIsImport);
    }, 500);
  },
  {
    immediate: true
  }
);
const validateSubmitData = () => {
  const data = props.data;
  const mainData = data.mainData;
  if (!data.customerServiceDeliveryTime) {
    OioMessage.error('请将请求发货日期填写完整!');
    return false;
  }
  if (!mainData.tmsDeliveryMethod) {
    OioMessage.error('请将交货方式填写完整!');
    return false;
  }
  // if (
  //   mainData.ariesIssuingMethodEnum !== 'ONE' &&
  //   mainData.tmsDeliveryMethod === 'LOGISTICS' &&
  //   !mainData.logisticsCode
  // ) {
  //   OioMessage.error('请将物流公司填写完整!');
  //   return false;
  // }
  if (!mainData.consigneeName || !mainData.consigneePhone || !mainData.deliveryAddress.address.cityCode || !mainData.deliveryAddress.detailAddress) {
    OioMessage.error('请将收货人信息和收货地址信息填写完整!');
    return false;
  }

  if( displayTableData.value.findIndex(n => n.itemOutCode  === "100014597") != -1  &&  selectRecords.value .findIndex(n => n.itemOutCode  === "100014597") == -1 )
  {
    message.warn('存在邮资必须包含邮资发货！');
    return false;
  }

  for (let i = 0; i < selectRecords.value.length; i++) {
    const row = selectRecords.value[i];
    if(row.itemOutCode === "100014597" && selectRecords.value.length === 1)
    {
      message.warn('无法只选择邮资物料发货！');
      return false;
    }
    // 是否存在未填写本次发货数量或者发货数量为0的行

    // 本次发货数量是否满足整件判断
    const hasErrorOperateNum = mainData.warehouseDeliveryTypeEnum === 'OVER_ALL' && !Number.isInteger(convertToLargePackage(row.operateNum, 'PCS', 'KAR', row.itemSpecifications));
    if (hasErrorOperateNum) {
      message.warn('存在本次发货数量非整件的商品，核对前请清空搜索条件');
      return false;
    }
    // 是否存在本次发货数量大于要货数量(是否存在前端扩展字段的isAbovePlanProductNum为true的商品)
    if (expandFieldsMap[row.tradeOrderDetailId]?.isAbovePlanProductNum) {
      message.warn('存在商品本次发货数量大于应用的要货计划中该商品的要货数量，核对前请清空搜索条件');
      return false;
    }
  }

  return true;
};
const isCounting = ref<boolean>(false);
const onSyncRefresh = async () => {
  try {
    isCounting.value = true;
    const submitTmsOrderDetails = cloneDeep(props.data.mainData.tmsOrderDetails);
    submitTmsOrderDetails.forEach((item) => {
      item.isSelected = !!item.isSelected;
      item.tradeOrderOptions = null;
      delete item._X_ROW_KEY;
      delete item.__draftId;
      delete item.isPartSubmitRow;
      delete item.itemKarNum;
    });

    await tmsFreshInventoryConstruct(props.rModel, {
      tradeOrderCode: props.data.mainData.tradeOrderCode,
      tmsOrderDetails: submitTmsOrderDetails
    });
    await onRefresh();
  } finally {
    isCounting.value = false;
  }
};

const onRefresh = async () => {
  try {
    tableLoading.value = true;
    await onTableDataChange({ changeType: 'sellerDeliveryWarehouse', selectedWarehouse: true });
    await getAccountBalanceApi();
  } finally {
    tableLoading.value = false;
  }
};
const onBatchEidtClick = async () => {
  editModalDataList.value = [{ id: 0 }];
  editModalVisible.value = true;
}
const changeDealOption = async (opt:string) => {
  try {
    tableLoading.value = true;
    console.log(displayTableData.value)
    console.log(customerDemandOpt.value)
    await dealOption(displayTableData.value.filter(n => n.isSelected).map(n => { return {id : n.tradeOrderDetailId, 'isMarkCustomerDemandNoDirect' : customerDemandOpt.value == 'MarkCustomerDemandNoDirect', 'isMarkCustomerDemandDirect' : customerDemandOpt.value == 'MarkCustomerDemandDirect', 'isMarkPackagingMaterialsCustomerDemandDirect' : customerDemandOpt.value == 'isMarkPackagingMaterialsCustomerDemandDirect','isMarkPackagingMaterialsCustomerDemandNoDirect' : customerDemandOpt.value == 'isMarkPackagingMaterialsCustomerDemandNoDirect' }}))
    //await onRefresh();
    props.mountedProcess();
  } finally {
    customerDemandVisible.value = false
    tableLoading.value = false;
  }
};

const onSubmitBtnClick = async (isClose: boolean, forceDelivery = false) => {
  if (!validateSubmitData()) return;
  submitLoading.value = true;
  try {
    await props.submitData(forceDelivery, displayTableData.value);
    message.success('发货成功!');
    if (isFullscreen.value) {
      toggleFullscreen();
    }
    if (isClose) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      PopupManager.INSTANCE.close();
    } else {
      props.mountedProcess();
      await handleDetailPageChange({ currentPage: 1, pageSize: 15 });
    }
    isApplyPlan.value = false;
    // 清空历史数据
    productTableDataHistoryArr.value = [];
    // 清空maxOperateNumMap
    maxOperateNumMap.value = {};
    // 清空前端扩展字段
    Object.assign(expandFieldsMap, {});
    // 清除要货明细数据
    Object.assign(planDetailObj, {});
  } catch (e: any) {
    const needReload = e?.errors?.some?.((_e: any) => _e?.extensions?.errorCode === '30200010');
    if (needReload) {
      props.mountedProcess();
      await handleDetailPageChange({ currentPage: 1, pageSize: 15 });
    }
    const errorCode = (e as any).errors[0].extensions.errorCode;
    if (errorCode == '60000500') {
      Modal.confirm({
        title: '提示',
        content: '该客户账期异常，继续发货请点击强制发货',
        okText: '强制发货',
        onOk: () => {
          onSubmitBtnClick(isClose, true);
        }
      });
    }
  } finally {
    //发货后更新客户账户信息
    await getAccountBalanceApi();
    submitLoading.value = false;
  }
};

const _deliveryAddressCopy = ref<Record<any, any>>({});
const _deliveryAddress = ref<Record<any, any>>({});

// 查询账户信息
const accountInfo = ref<any[]>([]);
watch(
  () => props.data.mainData?.tradeOrderCode,
  (val) => {
    if (val) {
      getAccountBalanceApi();
    }
  }
);
const getAccountBalanceApi = async () => {
  try {
    const res = await getAccountBalance(props.rModel, props.data.mainData.tradeOrderCode);
    if (res?.disFundBookList?.length) {
      let arr: any = [];
      res?.disFundBookList?.forEach((item) => {
        let obj = {
          fundTypeLabel: '',
          usableAmount: Number(item.usableAmount)
        };
        switch (item.fundType) {
          case 'BALANCE':
            obj.fundTypeLabel = '客户账户余额：现金 ';
            break;
          case 'REBATE':
            obj.fundTypeLabel = '权益金 ';
            break;
          case 'CREDIT':
            if (item.bizType === 'NORMAL') {
              obj.fundTypeLabel = '常规授信 ';
            } else if (item.bizType === 'SPECIAL') {
              obj.fundTypeLabel = '专款授信 ';
            }
            break;
          default:
            break;
        }
        if (item.fundType !== 'DEPOSIT') {
          arr.push(obj);
        }
      });
      const resultMap = new Map();
      arr.forEach((obj) => {
        // 尝试从Map中获取当前fundTypeLabel对应的value，如果Map中没有这个fundTypeLabel，则默认为0
        let currentValue = resultMap.get(obj.fundTypeLabel) || 0;
        // 将当前对象的value加到currentValue上
        currentValue += obj.usableAmount;
        // 将更新后的value存回Map中，与当前的fundTypeLabel关联
        resultMap.set(obj.fundTypeLabel, currentValue);
      });

      const resultArray: any = [];
      resultMap.forEach((usableAmount, fundTypeLabel) => {
        resultArray.push({ fundTypeLabel, usableAmount });
      });
      if (res?.sapRemainingAmount) {
        resultArray.push({ fundTypeLabel: '剩余可用', usableAmount: res.sapRemainingAmount });
      }
      accountInfo.value = resultArray;
    }
  } catch (error) {
    console.error('error===>', error);
  }
};

// 地址信息初始化
const stopAddressWatch = watch(
  () => props.data.selectedRegion,
  (val) => {
    if (val.length) {
      _selectedRegion.value = val;
      const copy = cloneDeep(props.data);
      _deliveryAddressCopy.value = copy.mainData?.deliveryAddressCopy ?? {};
      _deliveryAddress.value = copy.mainData?.deliveryAddress ?? {};
      _deliveryAddress.value.contactMan = copy.mainData?.consigneeName ?? '';
      _deliveryAddress.value.contactPhone = copy.mainData?.consigneePhone ?? '';
      stopAddressWatch();
    }
  }
);

const onSelectedRegionChange = (val) => {
  _selectedRegion.value = val;
  const address: Record<any, any> = {
    countryCode: 'CN',
    countryName: '中国'
  };
  const defaultObj = {
    name: '',
    code: ''
  };
  const province = props.data.regionOptions.find((el) => el.code === val[0]) ?? defaultObj;
  address.provinceName = province.name;
  address.provinceCode = province.code;

  const city = province.children?.find((el) => el.code === val[1]) ?? defaultObj;
  address.cityName = city.name;
  address.cityCode = city.code;

  const district = city.children?.find((el) => el.code === val[2]) ?? defaultObj;
  address.districtName = district.name;
  address.districtCode = district.code;

  const street = district.children?.find((el) => el.code === val[3]) ?? defaultObj;
  address.streetName = street.name;
  address.streetCode = street.code;

  _deliveryAddress.value.address = address;
};

const updateSelectedRegionFromMainData = () => {
  const address = _deliveryAddress.value.address;
  if (address) {
    _selectedRegion.value = [address.provinceCode, address.cityCode, address.districtCode, address.streetCode].filter((i) => !isNil(i));
  }
};

const queryAddress = async () => {
  const resData = await queryAddressDetail(props.rModel, {
    deliveryAddressCopy: _deliveryAddressCopy.value
  });
  _deliveryAddress.value = resData?.deliveryAddress ?? {};
  updateSelectedRegionFromMainData();
};

const onApplyAddressEdit = async () => {
  props.setData(
    {
      deliveryAddressCopy: _deliveryAddressCopy.value,
      deliveryAddress: _deliveryAddress.value,
      consigneeName: _deliveryAddress.value.contactMan,
      consigneePhone: _deliveryAddress.value.contactPhone
    },
    'mainData'
  );
  props.setData(_selectedRegion.value, 'selectedRegion');

  if (isApplyPlan.value) {
    const excludeIds = Object.keys(disabledEditFields.operateNum);
    setSubmitRows(excludeIds, true);
  }

  await props.mirrorConstruct('sellerDeliveryWarehouse', false, isApplyPlan.value);
};

const onDeliveryAddressCopyChange = async (val: string) => {
  _deliveryAddressCopy.value = props.data.addressOptions?.find((item) => item.id === val) ?? {};
  delete _deliveryAddressCopy.value.META_BIT;
  delete _deliveryAddressCopy.value._d_model;
  queryAddress();
};

const onCustomerDemandChange = async (val: string) => {
  customerDemandOpt.value = val;
};

const contentRef = ref<HTMLElement | undefined>();
const { isFullscreen, toggleFullscreen } = useFullscreen(contentRef);

const getPopupContainer = (triggerNode: HTMLElement) => {
  let curNode = triggerNode;
  while (curNode) {
    if (curNode.id === 'SG-content' || curNode.id === 'SG-PROMOTION-CELL') {
      return curNode;
    }
    curNode = curNode.parentNode as HTMLElement;
  }
  return document.body;
};
const getModalContainer = () => {
  const container = document.getElementById('SG-content');
  return container ?? document.body;
};
const handleDetailPageChange = async ({ currentPage, pageSize }) => {
  try {
    tableLoading.value = true;
    const res = await fetchPurchasingPlan(props.rModel, {
      tradeOrderCode: props.data.mainData.tradeOrderCode,
      planCurrentPage: currentPage,
      planPageSize: pageSize
    });
    detailTableData.value = res.purchasingPlanList || [];
    detailPagination.total = Number(res.totalPlanNum || 0);
  } finally {
    tableLoading.value = false;
  }
};

const cancelApplyPlan = async (row) => {
  try {
    tableLoading.value = true;
    disabledEditFields.operateNum = {};
    // 恢复历史数据
    props.setData(productTableDataHistoryArr.value.pop(), 'mainData');
    // 清除前端扩展字段的isAbovePlanProductNum
    for (const key in expandFieldsMap) {
      delete expandFieldsMap[key].isAbovePlanProductNum;
    }
    // 清除要货明细数据
    Object.assign(planDetailObj, {});

    row.applied = false;
  } finally {
    tableLoading.value = false;
  }
};

const applyPlan = async (row) => {
  try {
    tableLoading.value = true;

    // 记录历史数据
    productTableDataHistoryArr.value.push(cloneDeep(props.data.mainData));

    const res = await fetchPurchasingPlanDetail(props.rModel, { purchasingPlanId: row.id });
    res.deliAriesPurchasingPlanDetails.forEach((i) => {
      planDetailObj[i.tradeDetailId] = i;
    });

    let tmsOrderDetailsCopy = cloneDeep(props.data.mainData.tmsOrderDetails);
    tmsOrderDetailsCopy = tmsOrderDetailsCopy.filter((i) => {
      const j = res.deliAriesPurchasingPlanDetails.find((j) => j.tradeDetailId === i.tradeOrderDetailId);
      // 匹配到的行填充本次发货数量
      if (j) {
        i.operateNum = Math.min(j.unAllocedNum, i.availableNum);
        // 标识当前行是应用的数量，提交给后端
        i.appliedPlanNum = j.unAllocedNum;
        maxOperateNumMap[i.tradeOrderDetailId] = i.operateNum;
        //本次发货数量为0不显示
        if(i.appliedPlanNum <= 0 ){
          return false;
        }
        // 标识部分提交的数据
        i.isPartSubmitRow = true;
        return true;
      }
      // 其他行禁止编辑
      else {
        disabledEditFields.operateNum[i.tradeOrderDetailId + ''] = 1;
        return false;
      }
    });
    const obj = {
      ariesIssuingMethodEnum: row.issuingMethod,
      tmsDeliveryMethod: row.ariesTmsDeliveryMethodEnum,
      deliveryAreaTypeEnum: row.deliveryAreaTypeEnum,
      logisticsCode: row.ariesLogisticsProvider?.code ?? null,
      consigneeName: row.consigneeName,
      consigneePhone: row.consigneePhone,
      purchasingPlanCode: row.code,
      deliveryAddress: row.deliveryAddress,
      tmsOrderDetails: tmsOrderDetailsCopy,
      buyerRemark: row.remark,
      sellerRemark: row.sellerDesc
    };
    props.setData(obj, 'mainData');
    props.setData(row.expectedDeliveryTime, 'customerServiceDeliveryTime');

    _selectedRegion.value = [row.deliveryAddress.address.provinceCode, row.deliveryAddress.address.cityCode, row.deliveryAddress.address.districtCode];
    _deliveryAddressCopy.value = row.deliveryAddressCopy || {};
    _deliveryAddress.value = row.deliveryAddress || {};
    _deliveryAddress.value.contactMan = row.consigneeName || '';
    _deliveryAddress.value.contactPhone = row.consigneePhone || '';
    props.setData(row.consigneeFullAddress, 'mainData.deliveryAddress.address.fullAddress');

    await props.mirrorConstruct('sellerDeliveryWarehouse', false, true);

    row.applied = true;
  } catch (err) {
    console.error(err);
    // 恢复历史数据
    props.setData(productTableDataHistoryArr.value.pop(), 'mainData');
  } finally {
    tableLoading.value = false;
  }
};

const toggleApplyPlan = async (row) => {
  if (row.applied) {
    await cancelApplyPlan(row);
    isApplyPlan.value = false;
  } else {
    row.applied = true;
    await applyPlan(row);
    isApplyPlan.value = true;
  }
};

const viewPlan = (row) => {
  props.openPlanDetail(row.id);
};

const interval = setInterval(() => {
  if (props.data?.mainData?.tradeOrderCode) {
    handleDetailPageChange({ currentPage: 1, pageSize: 10 });
    clearInterval(interval);
  }
}, 100);

const handleAriesIssuingMethodChange = async (val) => {
  try {
    tableLoading.value = true;
    if (tmsDeliveryMethod.value === 'LOGISTICS') {
      await updateLogisticsOptions();
    }
    await nextTick();
    props.setData(deliveryAreaTypeEnum.value, 'mainData.deliveryAreaTypeEnum');
    props.setData(tmsDeliveryMethod.value, 'mainData.tmsDeliveryMethod');
    props.setData(deliveryAddressTypeEnum.value, 'mainData.deliveryAddressTypeEnum');

    if (isApplyPlan.value) {
      const excludeIds = Object.keys(disabledEditFields.operateNum);
      setSubmitRows(excludeIds, true);
    }

    await props.mirrorConstruct('sellerDeliveryWarehouse', false, isApplyPlan.value);
  } finally {
    tableLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_vxe_pager = _resolveComponent("vxe-pager")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_cascader = _resolveComponent("a-cascader")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["content", [_unref(isFullscreen) && 'send-goods-dialog-fullscreen']]),
    id: "SG-content",
    ref_key: "contentRef",
    ref: contentRef
  }, [
    _createVNode(_unref(OioSpin), {
      loading: tableLoading.value || __props.dataLoading
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(OioButton), {
                type: "primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (onSubmitBtnClick(true))),
                loading: submitLoading.value,
                disabled: editStatus.value !== 'CLOSED'
              }, {
                default: _withCtx(() => [
                  _createTextVNode("发货并关闭")
                ]),
                _: 1
              }, 8, ["loading", "disabled"]),
              _createVNode(_unref(OioButton), {
                type: "primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (onSubmitBtnClick(false))),
                loading: submitLoading.value,
                disabled: editStatus.value !== 'CLOSED'
              }, {
                default: _withCtx(() => [
                  _createTextVNode("发货且刷新")
                ]),
                _: 1
              }, 8, ["loading", "disabled"]),
              _createVNode(_unref(OioButton), {
                type: "primary",
                onClick: onBatchEidtClick
              }, {
                default: _withCtx(() => [
                  _createTextVNode("批量修改")
                ]),
                _: 1
              }),
              _createVNode(_unref(OioButton), {
                type: "primary",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (addressModalVisible.value = true))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("修改地址")
                ]),
                _: 1
              }),
              (__props.allCancelAction)
                ? (_openBlock(), _createBlock(_unref(OioButton), {
                    key: 0,
                    type: "primary",
                    onClick: __props.onAllCancel
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 整单取消 ")
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_unref(OioButton), {
                type: "primary",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (customerDemandVisible.value = true))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 客需 ")
                ]),
                _: 1
              }),
              _createVNode(ImportDialog, {
                "client-validate-fuction": validateImport,
                importCallback: importCallback,
                model: __props.importModel,
                "import-template-name": "批量修改商品发货数量,批量修改客需数量"
              }, null, 8, ["model"]),
              _createVNode(_unref(OioButton), {
                type: "primary",
                onClick: exportDataEvent,
                loading: exportLoading.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导出")
                ]),
                _: 1
              }, 8, ["loading"]),
              _createVNode(_unref(OioButton), {
                type: "primary",
                onClick: onSyncRefresh,
                loading: isCounting.value,
                disabled: isCounting.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 同步库存 ")
                ]),
                _: 1
              }, 8, ["loading", "disabled"]),
              _createVNode(_unref(OioButton), {
                type: "primary",
                onClick: onRefresh
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 刷新 ")
                ]),
                _: 1
              }),
              (__props.partCancelAction)
                ? (_openBlock(), _createBlock(_unref(OioButton), {
                    key: 1,
                    type: "primary",
                    onClick: __props.onPartCancel
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 部分取消 ")
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_a_select, {
                class: "oio-select",
                allowClear: "",
                value: deliAriesInventoryStatusEnum.value,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((deliAriesInventoryStatusEnum).value = $event)),
                style: {"width":"200px"},
                options: __props.inventoryStatusEnum,
                getPopupContainer: getPopupContainer,
                placeholder: "库存满足情况",
                onChange: filterInventoryStatus
              }, null, 8, ["value", "options"]),
              _createVNode(_component_a_select, {
                class: "oio-select",
                value: __props.data.mainData.warehouseDeliveryTypeEnum,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((__props.data.mainData.warehouseDeliveryTypeEnum) = $event)),
                disabled: _unref(warehouseDeliveryTypeDisabled),
                style: {"width":"200px"},
                options: _unref(warehouseDeliveryTypeOptions),
                getPopupContainer: getPopupContainer,
                placeholder: "整件/整散件",
                onChange: onWareHouseDeliveryChange
              }, null, 8, ["value", "disabled", "options"]),
              _createVNode(_unref(OioInput), {
                value: searchBGVal.value,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((searchBGVal).value = $event)),
                placeholder: "按BG分类搜索",
                style: {"width":"200px !important"},
                "allow-clear": ""
              }, null, 8, ["value"]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_a_select, {
                  class: "oio-select",
                  value: selectModel.value,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((selectModel).value = $event)),
                  style: {"width":"35%"},
                  allowClear: "",
                  options: selectModelOptions,
                  getPopupContainer: getPopupContainer,
                  placeholder: "请选择标签",
                  onChange: filterInventoryStatus,
                  maxTagCount: "responsive"
                }, null, 8, ["value"]),
                _createVNode(_component_a_select, {
                  class: "oio-select",
                  value: tagesValueArr.value,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((tagesValueArr).value = $event)),
                  style: {"width":"65%"},
                  allowClear: "",
                  options: _unref(goodsTagsTypeEnum),
                  getPopupContainer: getPopupContainer,
                  placeholder: "请选择标签",
                  mode: "multiple",
                  onChange: filterInventoryStatus,
                  maxTagCount: "responsive"
                }, null, 8, ["value", "options"])
              ]),
              _createVNode(_unref(OioInput), {
                value: searchERPStoreCodeVal.value,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((searchERPStoreCodeVal).value = $event)),
                placeholder: "按ERP库存地点编码搜索",
                style: {"width":"200px !important"},
                "allow-clear": ""
              }, null, 8, ["value"]),
              _createVNode(_unref(OioInput), {
                value: searchVal.value,
                "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((searchVal).value = $event)),
                placeholder: "按货号、商品名称、物料号搜索",
                style: {"width":"200px !important"},
                "allow-clear": ""
              }, null, 8, ["value"])
            ]),
            _createElementVNode("span", {
              style: {"font-size":"20px","margin-left":"10px","cursor":"pointer","text-align":"right"},
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_unref(toggleFullscreen) && _unref(toggleFullscreen)(...args)))
            }, [
              (!_unref(isFullscreen))
                ? (_openBlock(), _createBlock(_unref(FullscreenOutlined), { key: 0 }))
                : (_openBlock(), _createBlock(_unref(FullscreenExitOutlined), { key: 1 }))
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(OioForm), {
              ref: "formRef",
              style: {"--ss-ant-form-item-label-width":"auto","row-gap":"12px"},
              layout: "inline"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(OioFormItem), {
                  name: "customerServiceDeliveryTime",
                  label: "请求发货日期"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(OioDatePicker), {
                      value: __props.data.customerServiceDeliveryTime,
                      "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((__props.data.customerServiceDeliveryTime) = $event)),
                      "disabled-date": disabledDate,
                      style: {"width":"140px"},
                      "get-trigger-container": getPopupContainer
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(OioFormItem), {
                  name: "ariesIssuingMethodEnum",
                  label: "代发方式"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      class: "oio-select",
                      value: _unref(ariesIssuingMethodEnum),
                      "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => (_isRef(ariesIssuingMethodEnum) ? (ariesIssuingMethodEnum).value = $event : null)),
                      style: {"width":"170px"},
                      options: __props.data.mainData.ariesIssuingMethodOptions,
                      getPopupContainer: getPopupContainer,
                      disabled: !__props.data.mainData.hasIssuingMethod,
                      onChange: handleAriesIssuingMethodChange
                    }, null, 8, ["value", "options", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(OioFormItem), {
                  name: "tmsDeliveryMethod",
                  label: "交货方式"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      class: "oio-select",
                      value: _unref(tmsDeliveryMethod),
                      "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => (_isRef(tmsDeliveryMethod) ? (tmsDeliveryMethod).value = $event : null)),
                      style: {"width":"100px"},
                      options: _unref(pickerShippingType),
                      getPopupContainer: getPopupContainer,
                      onChange: _cache[15] || (_cache[15] = (val) => __props.setData(val, 'mainData.tmsDeliveryMethod'))
                    }, null, 8, ["value", "options"])
                  ]),
                  _: 1
                }),
                (_unref(tmsDeliveryMethod) === 'LOGISTICS')
                  ? (_openBlock(), _createBlock(_unref(OioFormItem), {
                      key: 0,
                      name: "logisticsProvider",
                      label: "物流公司"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          class: "oio-select",
                          value: __props.data.mainData.logisticsCode,
                          "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((__props.data.mainData.logisticsCode) = $event)),
                          style: {"width":"100px"},
                          options: logisticsProviderOptions.value,
                          getPopupContainer: getPopupContainer,
                          placeholder: "请选择"
                        }, null, 8, ["value", "options"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_unref(OioFormItem), {
                  name: "sellerRemark",
                  label: "卖家备注"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(OioInput), {
                      value: __props.data.mainData.sellerRemark,
                      "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((__props.data.mainData.sellerRemark) = $event)),
                      style: {"width":"200px"}
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_a_tooltip, { placement: "top" }, {
              title: _withCtx(() => [
                _createElementVNode("span", null, "订单编码：" + _toDisplayString(__props.data.mainData?.tradeOrderCode) + "     经销商名称：" + _toDisplayString(__props.data.mainData?.buyerPartnerName) + "     买家备注：" + _toDisplayString(__props.data.mainData?.buyerRemark) + "     收货信息：" + _toDisplayString(__props.data.mainData?.consigneeName) + "," + _toDisplayString(__props.data.mainData?.consigneePhone) + "," + _toDisplayString(__props.data.mainData?.deliveryAddress?.address?.fullAddress), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, " 订单编码：" + _toDisplayString(__props.data.mainData?.tradeOrderCode) + "     经销商名称：" + _toDisplayString(__props.data.mainData?.buyerPartnerName) + "     买家备注：" + _toDisplayString(__props.data.mainData?.buyerRemark) + "     收货信息：" + _toDisplayString(__props.data.mainData?.consigneeName) + "," + _toDisplayString(__props.data.mainData?.consigneePhone) + "," + _toDisplayString(__props.data.mainData?.deliveryAddress?.address?.fullAddress), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            style: _normalizeStyle([{"flex":"auto"}, { height: isExpandPlan.value ? '250px' : '500px' }])
          }, [
            _createVNode(_component_vxe_table, {
              "header-align": "center",
              border: "",
              ref_key: "tableRef",
              ref: tableRef,
              height: "auto",
              size: "mini",
              "keep-source": "",
              "column-config": { resizable: true },
              data: displayTableData.value,
              "edit-config": { trigger: 'click', mode: 'cell', beforeEditMethod: beforeEditMethod },
              "scroll-x": { enabled: false },
              "scroll-y": { enabled: true, gt: 0, oSize: 20 },
              "checkbox-config": { checkField: 'isSelected', reserve: true },
              "max-height": 'auto',
              "row-config": { keyField: 'tradeOrderDetailId' },
              onCheckboxChange: _cache[18] || (_cache[18] = () => checkboxChangeEvent()),
              onCheckboxAll: _cache[19] || (_cache[19] = () => checkboxChangeEvent()),
              onEditActived: _cache[20] || (_cache[20] = ($event: any) => (editStatus.value = 'OPEN')),
              onEditClosed: _cache[21] || (_cache[21] = ($event: any) => (editStatus.value = 'CLOSED'))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_vxe_column, {
                  type: "checkbox",
                  fixed: "left",
                  width: "40",
                  align: "center"
                }),
                _createVNode(_component_vxe_column, {
                  type: "seq",
                  title: "行号",
                  fixed: "left",
                  width: "50"
                }),
                _createVNode(_component_vxe_column, {
                  fixed: "left",
                  field: "itemOutCode",
                  title: "ERP商品编码",
                  width: "110"
                }),
                _createVNode(_component_vxe_column, {
                  fixed: "left",
                  field: "itemName",
                  title: "商品名称",
                  "min-width": "210",
                  "show-overflow": ""
                }),
                _createVNode(_component_vxe_column, {
                  field: "itemColor",
                  title: "商品颜色",
                  width: "100",
                  sortable: ""
                }),
                _createVNode(_component_vxe_column, {
                  field: "availableNum",
                  title: "可用库存",
                  width: "100",
                  sortable: ""
                }),
                _createVNode(_component_vxe_column, {
                  field: "deliAriesInventoryStatusEnum",
                  title: "库存满足情况",
                  width: "120",
                  sortable: ""
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("div", null, _toDisplayString(__props.formatInventoryStatus(row.deliAriesInventoryStatusEnum)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "undeliveredNum",
                  title: "待发货数量",
                  width: "100"
                }),
                _createVNode(_component_vxe_column, {
                  field: "operateNum",
                  title: "本次发货数量",
                  "edit-render": { autofocus: '.vxe-input--inner', placeholder: '请点击输入' },
                  width: "130"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("span", null, _toDisplayString(row.operateNum), 1),
                      _createVNode(_unref(ElTooltip), {
                        placement: "top",
                        teleported: false
                      }, {
                        content: _withCtx(() => [
                          _hoisted_11
                        ]),
                        default: _withCtx(() => [
                          _withDirectives(_createVNode(_unref(ExclamationCircleOutlined), { style: {"color":"red","font-size":"16px","cursor":"pointer","margin-left":"auto"} }, null, 512), [
                            [_vShow, 
                        __props.data.mainData.warehouseDeliveryTypeEnum === 'OVER_ALL' &&
                        !Number.isInteger(_unref(convertToLargePackage)(row.operateNum || 0, 'PCS', 'KAR', row.itemSpecifications))
                      ]
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  edit: _withCtx((scope) => [
                    _createVNode(_component_a_input_number, {
                      class: "oio-input-number",
                      value: scope.row.operateNum,
                      "onUpdate:value": ($event: any) => ((scope.row.operateNum) = $event),
                      min: 0,
                      style: {"width":"100%"},
                      onBlur: (val) => onTableDataChange({ changeType: 'operateNum', row: scope.row }),
                      controls: false,
                      disabled: !scope.row.sellerDeliveryWarehouse?.id
                    }, null, 8, ["value", "onUpdate:value", "onBlur", "disabled"])
                  ]),
                  _: 1
                }, 8, ["edit-render"]),
                _createVNode(_component_vxe_column, {
                  field: "customerDemandNum",
                  title: "本次客需数量",
                  "edit-render": { autofocus: '.vxe-input--inner', placeholder: '请点击输入' },
                  width: "130"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("span", null, _toDisplayString(row.customerDemandNum), 1)
                  ]),
                  edit: _withCtx((scope) => [
                    _createVNode(_component_a_input_number, {
                      class: "oio-input-number",
                      value: scope.row.customerDemandNum,
                      "onUpdate:value": ($event: any) => ((scope.row.customerDemandNum) = $event),
                      min: 0,
                      style: {"width":"100%"},
                      controls: false
                    }, null, 8, ["value", "onUpdate:value"])
                  ]),
                  _: 1
                }, 8, ["edit-render"]),
                _createVNode(_component_vxe_column, {
                  title: "发货仓库",
                  "min-width": "250",
                  "edit-render": { autofocus: '.vxe-input--inner', placeholder: '请点击选择' }
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.sellerDeliveryWarehouse)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(scope.row.sellerDeliveryWarehouse.name), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_13, _hoisted_15))
                  ]),
                  edit: _withCtx((scope) => [
                    _createVNode(_component_a_select, {
                      id: "SG-PROMOTION-CELL",
                      class: "oio-select",
                      "dropdown-class-name": "oio-select-dropdown",
                      value: scope.row.sellerDeliveryWarehouse?.id,
                      "show-search": "",
                      placeholder: "按仓库名称、仓库编码搜索",
                      style: {"width":"100%"},
                      "default-active-first-option": false,
                      "show-arrow": false,
                      "filter-option": false,
                      options: expandFieldsMap[scope.row.tradeOrderDetailId]?.warehouseOptions ?? [],
                      fieldNames: { label: 'name', value: 'id' },
                      onFocus: ($event: any) => (handleSearchWarehouse({ row: scope.row })),
                      onSearch: (val) => _unref(debounceSearchWarehouse)({ row: scope.row, searchKey: val }),
                      onChange: (id) => handleWarehouseChange(id, scope.row),
                      getPopupContainer: getPopupContainer
                    }, null, 8, ["value", "options", "onFocus", "onSearch", "onChange"])
                  ]),
                  _: 1
                }, 8, ["edit-render"]),
                _createVNode(_component_vxe_column, {
                  field: "characteristics",
                  title: "产品特性",
                  "min-width": "150"
                }),
                _createVNode(_component_vxe_column, {
                  field: "itemKarNum",
                  title: "本次发货件数",
                  "min-width": "150"
                }),
                _createVNode(_component_vxe_column, {
                  title: "换算关系",
                  width: "150"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("span", null, _toDisplayString(_unref(generateConvertRelationStr)(row.itemSpecifications)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  title: "当前要货待发数量",
                  width: "160"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("span", null, _toDisplayString(isApplyPlan.value ? planDetailObj[row.tradeOrderDetailId]?.unAllocedNum : '-'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "orderDetailItemNum",
                  title: "下单数量",
                  width: "100"
                }),
                _createVNode(_component_vxe_column, {
                  field: "orderDetailClosedNum",
                  title: "已取消数量",
                  width: "100"
                }),
                _createVNode(_component_vxe_column, {
                  field: "deliveredNum",
                  title: "已发货数量",
                  width: "100"
                }),
                _createVNode(_component_vxe_column, {
                  field: "purchasePlanNum",
                  title: "总要货数量",
                  width: "100"
                }),
                _createVNode(_component_vxe_column, {
                  title: "当前要货数量",
                  width: "100"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("span", null, _toDisplayString(isApplyPlan.value ? planDetailObj[row.tradeOrderDetailId]?.itemPurchasingNum : '-'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "materialGroupName",
                  title: "物料组",
                  width: "150",
                  sortable: "",
                  "show-overflow": ""
                }),
                _createVNode(_component_vxe_column, {
                  field: "factoryPrice",
                  title: "出厂价",
                  width: "100",
                  formatter: _unref(vxeTableRemoveZeroFormatter),
                  sortable: ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_vxe_column, {
                  field: "settlementDeductionRate",
                  title: "结算扣率",
                  formatter: _unref(vxeTableRemoveZeroFormatter),
                  width: "100"
                }, null, 8, ["formatter"]),
                _createVNode(_component_vxe_column, {
                  field: "settlementPrice",
                  title: "结算单价",
                  formatter: _unref(vxeTableRemoveZeroFormatter),
                  width: "100"
                }, null, 8, ["formatter"]),
                _createVNode(_component_vxe_column, {
                  field: "actualAmount",
                  title: "行成交金额",
                  formatter: _unref(vxeTableRemoveZeroFormatter),
                  width: "100"
                }, null, 8, ["formatter"]),
                _createVNode(_component_vxe_column, {
                  field: "orderDetailRebatePayAmount",
                  title: "行权益金优惠金额",
                  formatter: _unref(vxeTableRemoveZeroFormatter),
                  width: "150"
                }, null, 8, ["formatter"]),
                _createVNode(_component_vxe_column, {
                  field: "settlementAmount",
                  title: "行结算金额",
                  formatter: _unref(vxeTableRemoveZeroFormatter),
                  width: "100"
                }, null, 8, ["formatter"]),
                _createVNode(_component_vxe_column, {
                  field: "settlementAmountTrade",
                  title: "行结算金额(订单明细)",
                  visible: false,
                  width: "100"
                }),
                _createVNode(_component_vxe_column, {
                  title: "标签",
                  "min-width": "110",
                  "show-overflow": ""
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.tradeOrderOptions)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.tradeOrderOptions, (option, index) => {
                            return (_openBlock(), _createBlock(_unref(OioTag), {
                              key: index,
                              bordered: false,
                              color: _unref(tagColorMap)[option]
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(tagViewMap)[option]), 1)
                              ]),
                              _: 2
                            }, 1032, ["color"]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "productBelong",
                  title: "BG分类",
                  width: "150",
                  "show-overflow": ""
                }),
                _createVNode(_component_vxe_column, {
                  field: "ruleName",
                  title: "推广方案名称",
                  width: "150",
                  "show-overflow": ""
                }),
                _createVNode(_component_vxe_column, {
                  field: "assemblyItemDisplay",
                  title: "关联子件",
                  width: "300",
                  "show-overflow": ""
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row.assemblyItemDisplay), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "deliverText",
                  title: "交货日期文本",
                  width: "150"
                }),
                _createVNode(_component_vxe_column, {
                  field: "deliveryWarehouseCode",
                  title: "发货库存地点",
                  width: "150"
                }),
                _createVNode(_component_vxe_column, {
                  field: "deliveryFactoryCode",
                  title: "发货工厂",
                  width: "150"
                })
              ]),
              _: 1
            }, 8, ["data", "edit-config"])
          ], 4),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", null, [
              _createElementVNode("span", null, "共 " + _toDisplayString(__props.data.mainData.tmsOrderDetails && __props.data.mainData.tmsOrderDetails.length) + " 条，", 1),
              _createElementVNode("span", null, "已选 " + _toDisplayString(_unref(selectRecords).length) + " 条", 1)
            ]),
            _createElementVNode("div", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accountInfo.value, (item, index) => {
                return (_openBlock(), _createElementBlock("span", {
                  class: "price-label",
                  key: index
                }, [
                  (index != 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, ","))
                    : _createCommentVNode("", true),
                  _createTextVNode(_toDisplayString(item.fundTypeLabel), 1),
                  _createElementVNode("span", _hoisted_20, _toDisplayString(Number(item.usableAmount).toFixed(2)), 1),
                  _createTextVNode("元")
                ]))
              }), 128)),
              _createElementVNode("span", _hoisted_21, [
                _createTextVNode("本次发货合计："),
                _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(removeDecimalZero)(_unref(totalAmount).toFixed(2))), 1),
                _createTextVNode("元")
              ]),
              _createElementVNode("span", _hoisted_23, [
                _createTextVNode("本次发货合计（件）："),
                _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(removeDecimalZero)(_unref(totalKarNum).toString())), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createVNode(_unref(OioButton), {
              type: "link",
              onClick: _cache[22] || (_cache[22] = ($event: any) => (isExpandPlan.value = !isExpandPlan.value))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(isExpandPlan.value ? '隐藏' : '展开') + " ", 1),
                (!isExpandPlan.value)
                  ? (_openBlock(), _createBlock(_unref(DownOutlined), {
                      key: 0,
                      class: "expand-icon"
                    }))
                  : (_openBlock(), _createBlock(_unref(UpOutlined), {
                      key: 1,
                      class: "expand-icon"
                    }))
              ]),
              _: 1
            })
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_vxe_table, {
                "header-align": "center",
                border: "",
                height: "auto",
                size: "mini",
                ref_key: "tableDetailRef",
                ref: tableDetailRef,
                "keep-source": "",
                "column-config": { resizable: true },
                data: detailTableData.value,
                "edit-config": { trigger: 'click', mode: 'cell' },
                "scroll-x": { enabled: false },
                "scroll-y": { enabled: true, gt: 0, oSize: 20 },
                "checkbox-config": { checkField: 'isSelected', reserve: true },
                "row-config": { keyField: 'id' },
                onCheckboxChange: checkboxChangeEventDetail,
                onCheckboxAll: checkboxChangeEventDetail
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_vxe_column, {
                    type: "checkbox",
                    fixed: "left",
                    width: "50",
                    align: "center"
                  }),
                  _createVNode(_component_vxe_column, {
                    type: "seq",
                    title: "行号",
                    fixed: "left",
                    width: "50"
                  }),
                  _createVNode(_component_vxe_column, {
                    fixed: "left",
                    field: "code",
                    title: "要货计划编码",
                    width: "120"
                  }),
                  _createVNode(_component_vxe_column, {
                    field: "purchasedNumTotal",
                    title: "要货数量",
                    width: "100",
                    sortable: ""
                  }),
                  _createVNode(_component_vxe_column, {
                    field: "expectedDeliveryTime",
                    title: "期望发货时间",
                    sortable: ""
                  }),
                  _createVNode(_component_vxe_column, {
                    field: "consigneeName",
                    title: "收货人",
                    width: "100"
                  }),
                  _createVNode(_component_vxe_column, {
                    field: "consigneeFullAddress",
                    title: "收货地址",
                    width: "300"
                  }),
                  _createVNode(_component_vxe_column, {
                    title: "操作",
                    width: "210"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createElementVNode("div", _hoisted_29, [
                        _withDirectives(_createVNode(_unref(OioButton), {
                          type: "link",
                          onClick: ($event: any) => (toggleApplyPlan(row)),
                          danger: row.applied
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(row.applied ? '取消应用' : '应用要货计划'), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick", "danger"]), [
                          [_vShow, !isApplyPlan.value || row.applied]
                        ]),
                        _createVNode(_unref(OioButton), {
                          type: "link",
                          onClick: ($event: any) => (viewPlan(row))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("查看要货计划")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_vxe_pager, {
                background: "",
                style: {"margin-left":"auto"},
                "current-page": detailPagination.page,
                "onUpdate:current-page": _cache[23] || (_cache[23] = ($event: any) => ((detailPagination.page) = $event)),
                "page-size": detailPagination.size,
                "onUpdate:page-size": _cache[24] || (_cache[24] = ($event: any) => ((detailPagination.size) = $event)),
                total: detailPagination.total,
                layouts: ['Total', 'PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes', 'FullJump'],
                onPageChange: handleDetailPageChange
              }, null, 8, ["current-page", "page-size", "total"])
            ])
          ], 512), [
            [_vShow, isExpandPlan.value]
          ])
        ])
      ]),
      _: 1
    }, 8, ["loading"]),
    _createVNode(_unref(OioModal), {
      visible: editModalVisible.value,
      "onUpdate:visible": _cache[28] || (_cache[28] = ($event: any) => ((editModalVisible).value = $event)),
      title: "批量修改",
      width: "medium",
      "get-trigger-container": getModalContainer
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(OioButton), {
          onClick: _cache[27] || (_cache[27] = ($event: any) => (editModalVisible.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_unref(OioButton), {
          type: "primary",
          onClick: onSubmitBatchEdit,
          loading: editModalConfirmLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editModalDataList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "edit-row",
            key: item.id
          }, [
            _hoisted_31,
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_a_select, {
                class: "oio-select",
                "dropdown-class-name": "oio-select-dropdown",
                value: item.type,
                "onUpdate:value": ($event: any) => ((item.type) = $event),
                placeholder: "请选择",
                style: {"width":"100%"},
                "default-active-first-option": false,
                options: _unref(displayEditTypeOptions),
                getPopupContainer: getPopupContainer
              }, null, 8, ["value", "onUpdate:value", "options"])
            ]),
            _hoisted_33,
            _createElementVNode("div", _hoisted_34, [
              (item.type && ['operateNum'].includes(item.type))
                ? (_openBlock(), _createBlock(_component_a_input_number, {
                    key: 0,
                    class: "oio-input-number",
                    value: item.value,
                    "onUpdate:value": ($event: any) => ((item.value) = $event),
                    min: 0,
                    style: {"width":"100%"},
                    controls: false
                  }, null, 8, ["value", "onUpdate:value"]))
                : (item.type && ['sellerDeliveryWarehouse'].includes(item.type))
                  ? (_openBlock(), _createBlock(_component_a_select, {
                      key: 1,
                      class: "oio-select",
                      "dropdown-class-name": "oio-select-dropdown",
                      value: item.value?.id,
                      "show-search": "",
                      placeholder: "按仓库名称、仓库编码搜索",
                      style: {"width":"100%"},
                      "default-active-first-option": false,
                      "show-arrow": false,
                      "filter-option": false,
                      options: allWarehouseOptions.value,
                      fieldNames: { label: 'name', value: 'id' },
                      onFocus: _cache[25] || (_cache[25] = ($event: any) => (handleSearchWarehouse())),
                      onSearch: _cache[26] || (_cache[26] = (val) => _unref(debounceSearchWarehouse)({ searchKey: val })),
                      onChange: 
              (id) => {
                item.value = getWarehouseById(id);
              }
            ,
                      getPopupContainer: getPopupContainer
                    }, null, 8, ["value", "options", "onChange"]))
                  : (item.type && ['isTransfer'].includes(item.type))
                    ? (_openBlock(), _createBlock(_unref(OioSwitch), {
                        key: 2,
                        checked: item.value,
                        "onUpdate:checked": ($event: any) => ((item.value) = $event)
                      }, null, 8, ["checked", "onUpdate:checked"]))
                    : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_35, [
              _withDirectives(_createVNode(_unref(MinusCircleOutlined), {
                onClick: ($event: any) => (removeEditModalRow(item.id))
              }, null, 8, ["onClick"]), [
                [_vShow, editModalDataList.value.length > 1]
              ]),
              _withDirectives(_createVNode(_unref(PlusCircleOutlined), { onClick: addEditModalRow }, null, 512), [
                [_vShow, index === editModalDataList.value.length - 1 && index !== _unref(displayEditTypeOptions).length - 1]
              ])
            ])
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(OioModal), {
      "wrapper-class-name": "send-goods-address-edit-modal",
      visible: addressModalVisible.value,
      "onUpdate:visible": _cache[39] || (_cache[39] = ($event: any) => ((addressModalVisible).value = $event)),
      title: "修改地址",
      width: "medium",
      "get-trigger-container": getModalContainer
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(OioButton), {
          onClick: _cache[38] || (_cache[38] = ($event: any) => (addressModalVisible.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_unref(OioButton), {
          type: "primary",
          onClick: handleEditArress
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(OioForm), {
          ref_key: "addressFormRef",
          ref: addressFormRef
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(OioRow), null, {
              default: _withCtx(() => [
                _createVNode(_unref(OioCol), { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(OioFormItem), { label: "本次发货范围" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio_group, {
                          value: _unref(deliveryAreaTypeEnum),
                          "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => (_isRef(deliveryAreaTypeEnum) ? (deliveryAreaTypeEnum).value = $event : null)),
                          disabled: _unref(sendAreaDisabled),
                          onChange: _cache[30] || (_cache[30] = (e) => __props.setData(e.target.value, 'mainData.deliveryAreaTypeEnum'))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sendAreaOptions), (item, index) => {
                              return (_openBlock(), _createBlock(_component_a_radio, {
                                key: index,
                                value: item.value
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.label), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["value", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(OioCol), { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(OioFormItem), { label: "配送至" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio_group, {
                          value: _unref(deliveryAddressTypeEnum),
                          "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => (_isRef(deliveryAddressTypeEnum) ? (deliveryAddressTypeEnum).value = $event : null)),
                          onChange: handleDeliveryAddressTypeChange
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(addressTypeOptions), (item, index) => {
                              return (_openBlock(), _createBlock(_component_a_radio, {
                                key: index,
                                value: item.value
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.label), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _withDirectives(_createVNode(_unref(OioFormItem), {
              label: "选择地址",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  class: "oio-select",
                  value: _deliveryAddressCopy.value.id,
                  options: __props.data.addressOptions,
                  showSearch: "",
                  placeholder: "选择地址",
                  fieldNames: {
              label: 'labelTitle',
              value: 'id'
            },
                  onChange: onDeliveryAddressCopyChange,
                  optionFilterProp: "labelTitle",
                  getPopupContainer: getPopupContainer
                }, null, 8, ["value", "options"])
              ]),
              _: 1
            }, 512), [
              [_vShow, !_unref(showCustomAddress)]
            ]),
            _createVNode(_unref(OioFormItem), {
              label: "地址信息",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_cascader, {
                  class: "oio-select oio-cascader",
                  value: _selectedRegion.value,
                  style: {"width":"100%"},
                  "field-names": { label: 'name', value: 'code' },
                  options: __props.data.regionOptions,
                  placeholder: _unref(showCustomAddress) ? '地址信息' : '',
                  "show-search": { filterAddressInfo: filterAddressInfo },
                  onChange: onSelectedRegionChange,
                  disabled: !_unref(showCustomAddress),
                  getPopupContainer: getPopupContainer,
                  allowClear: false
                }, null, 8, ["value", "options", "placeholder", "show-search", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_unref(OioRow), null, {
              default: _withCtx(() => [
                _createVNode(_unref(OioCol), { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(OioFormItem), {
                      label: "收货人",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(OioInput), {
                          value: _deliveryAddress.value.contactMan,
                          "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => ((_deliveryAddress.value.contactMan) = $event)),
                          placeholder: _unref(showCustomAddress) ? '请输入' : '',
                          disabled: !_unref(showCustomAddress)
                        }, null, 8, ["value", "placeholder", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(OioCol), { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(OioFormItem), {
                      label: "手机号码",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(OioInput), {
                          value: _deliveryAddress.value.contactPhone,
                          "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => ((_deliveryAddress.value.contactPhone) = $event)),
                          placeholder: _unref(showCustomAddress) ? '请输入' : '',
                          disabled: !_unref(showCustomAddress)
                        }, null, 8, ["value", "placeholder", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(OioCol), { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(OioFormItem), { label: "固定电话" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(OioInput), {
                          value: _deliveryAddress.value.contactLandPhone,
                          "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => ((_deliveryAddress.value.contactLandPhone) = $event)),
                          placeholder: _unref(showCustomAddress) ? '请输入' : '',
                          disabled: !_unref(showCustomAddress)
                        }, null, 8, ["value", "placeholder", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(OioRow), null, {
              default: _withCtx(() => [
                _createVNode(_unref(OioCol), { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(OioFormItem), { label: "电子邮箱" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(OioInput), {
                          value: _deliveryAddress.value.contactEmail,
                          "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => ((_deliveryAddress.value.contactEmail) = $event)),
                          placeholder: _unref(showCustomAddress) ? '请输入' : '',
                          disabled: !_unref(showCustomAddress)
                        }, null, 8, ["value", "placeholder", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(OioCol), { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(OioFormItem), { label: "邮政编码" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(OioInput), {
                          value: _deliveryAddress.value.zipCode,
                          "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => ((_deliveryAddress.value.zipCode) = $event)),
                          placeholder: _unref(showCustomAddress) ? '请输入' : '',
                          disabled: !_unref(showCustomAddress)
                        }, null, 8, ["value", "placeholder", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(OioFormItem), {
              label: "详细街道地址",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(OioInput), {
                  value: _deliveryAddress.value.detailAddress,
                  "onUpdate:value": _cache[37] || (_cache[37] = ($event: any) => ((_deliveryAddress.value.detailAddress) = $event)),
                  placeholder: _unref(showCustomAddress) ? '详细街道地址' : '',
                  disabled: !_unref(showCustomAddress)
                }, null, 8, ["value", "placeholder", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(OioModal), {
      visible: customerDemandVisible.value,
      "onUpdate:visible": _cache[41] || (_cache[41] = ($event: any) => ((customerDemandVisible).value = $event)),
      title: "客需场景选择",
      width: "small",
      "get-trigger-container": getModalContainer
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(OioButton), {
          onClick: _cache[40] || (_cache[40] = ($event: any) => (customerDemandVisible.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_unref(OioButton), {
          type: "primary",
          onClick: changeDealOption
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(OioForm), {
          ref_key: "customerDemandFormRef",
          ref: customerDemandFormRef
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(OioFormItem), { label: "客需场景选择" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  class: "oio-select",
                  value: customerDemandOpt.value,
                  options: customerDemandOptions.value,
                  showSearch: "",
                  placeholder: "",
                  onChange: onCustomerDemandChange,
                  getPopupContainer: getPopupContainer
                }, null, 8, ["value", "options"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 2))
}
}

})